import { render, staticRenderFns } from "./PowerTree.vue?vue&type=template&id=5241f737&scoped=true&"
import script from "./PowerTree.vue?vue&type=script&lang=js&"
export * from "./PowerTree.vue?vue&type=script&lang=js&"
import style0 from "./PowerTree.vue?vue&type=style&index=0&id=5241f737&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5241f737",
  null
  
)

export default component.exports